import { render, staticRenderFns } from "./CustomDocuments.vue?vue&type=template&id=5a10a4a0&"
import script from "./CustomDocuments.vue?vue&type=script&lang=js&"
export * from "./CustomDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports